// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFound_NotFound__AmwKj"};